<template>
  <div v-if="property && localProperty"
    class="columns is-multiline">
    <b-field
      :label="$t('addEditNomenclatureType.ajoutChamp.ordre')"
      class="column is-2">
      <qd-numberinput
        v-model="localProperty.propertyOrder"
        :controls="false"/>
    </b-field>
    <b-field
      :label="$t('addEditNomenclatureType.ajoutChamp.label')"
      class="column is-2">
      <b-input
        v-model="localProperty.label"/>
    </b-field>
    <div class="column is-3 mgb-0">
      <b-field :label="$t('addEditNomenclatureType.ajoutChamp.type')">
        <b-select
          @input="onTypeChange"
          :value="localProperty.type"
          expanded>
          <option
            v-for="typeChamp in constantes.TYPE_PROPRERTIES"
            :key="typeChamp.code"
            :value="typeChamp.code">
            {{ $t(typeChamp.libelle) }}
          </option>
        </b-select>
      </b-field>
      <b-field v-if="localProperty.type === constantes.TABLEAU"
        :label="$t('addEditNomenclatureType.ajoutChamp.valeurs')"
        custom-class="has-text-default is-size-7 mgr-2"
        horizontal>
        <qd-taginput
          v-model="localProperty.arrayValues"
          type="is-primary"/>
        </b-field>
    </div>
    <input-champs
      :property="localProperty"
      isModeEdit/>
    <div class="column is-1">
      <div class="mgt-30px width-max-content" @click="$emit('remove')">
        <qd-icon icon='delete-forever' type="is-danger"/>
      </div>
    </div>
    <b-modal
      v-model="openPopUpPrevention"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('addEditNomenclatureType.messWarning.changeType')"
        :messDescription="$t('addEditNomenclatureType.messWarning.message')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.apply')"
        @yes="handlerChangeTypePropertyYes"
        @no="handlerChangeTypePropertyNo"
      />
    </b-modal>
  </div>
</template>

<script>
import inputChamps from '@/components/parametrage/nomenclature/inputChamps';
import {
  TYPE_PROPRERTIES,
  TABLEAU,
} from '@/configuration/jsonEditor/jsonEditorConfig';
import cloneDeep from 'lodash/cloneDeep';
import popUpPrevention from '@/components/general/popUpPrevention';

export default {
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputChamps,
    popUpPrevention,
  },
  data() {
    return {
      localProperty: null,
      constantes: {
        TYPE_PROPRERTIES,
        TABLEAU,
      },
      propertyChange: null,
      openPopUpPrevention: false,
    };
  },
  watch: {
    localProperty: {
      handler(newProperty) {
        this.$emit('update:property', newProperty);
      },
      deep: true,
    },
  },
  methods: {
    onTypeChange(newType) {
      this.propertyChange = {
        oldType: this.localProperty.type,
        newType,
      };
      this.localProperty.type = newType;

      this.openPopUpPrevention = true;
    },
    handlerChangeTypePropertyYes() {
      const { newType } = this.propertyChange;
      this.localProperty.type = newType;
      this.localProperty.default = null;
      this.localProperty.defaultValue = null;
      this.localProperty.arrayValues = [];
      this.propertyChange = null;
      this.openPopUpPrevention = false;
    },
    handlerChangeTypePropertyNo() {
      const { oldType } = this.propertyChange;
      this.localProperty.type = oldType;
      this.propertyChange = null;
      this.openPopUpPrevention = false;
    },
  },
  mounted() {
    this.localProperty = cloneDeep(this.property);
  },
};
</script>
